import { memo, useCallback, useLayoutEffect, useRef, useState } from 'react';

import { Box, Tooltip } from '@mui/material';

const TEXT_CELL_SX = {
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '0.875rem',
  color: '#615E6F',
  fontFamily: 'Neue Frutiger World',
} as const;

export interface TextCellProps {
  value: string | number | null | undefined;
}

export const TextCell = memo(({ value }: TextCellProps) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const measureOverflow = useCallback(() => {
    const el = textRef.current;
    if (el) setIsOverflowing(el.scrollWidth > el.clientWidth);
  }, []);

  useLayoutEffect(() => {
    measureOverflow();
  }, [value, measureOverflow]);

  const displayValue = value != null ? String(value) : '';

  const content = (
    <Box ref={textRef} component="span" sx={TEXT_CELL_SX} onMouseEnter={measureOverflow}>
      {displayValue}
    </Box>
  );

  if (isOverflowing) {
    return (
      <Tooltip title={displayValue} arrow>
        {content}
      </Tooltip>
    );
  }

  return content;
});
TextCell.displayName = 'TextCell';
